export const terminateAgreementInitialValues = () => ({
  reason: '',
  terms: false,
});
